/* eslint-disable */
import { Dimensions } from "react-native"
const screenDim = Dimensions.get("window")
const screenWidth = screenDim.width
const screenHeight = screenDim.height

const width = screenWidth
const height = screenHeight

// default margin to remove from tom's layout
const subtractMargin = 7 // it's 10 in the jpg
const translate = ( x, y, w, h ) => {
  let sub = subtractMargin / 1000 * width
  return {
    top : (y / 1000 * width) - sub
  , left : (x / 1000 * width) - sub
  , width : (w / 1000 * width) + sub*2
  , height : (h / 1000 * width) + sub*2
  }
}
const getMosaicLayout = (mosaicIndex) => {
  let layout = []
  switch (mosaicIndex % 3) {
    case 0: return [// wall-1.jpg
        // 1, 2, 3
        translate(10,10,300,370), translate(320,10,280,370), translate(610,10,380,370)
        // 4, 5
      , translate(10,390,485,280), translate(505,390, 485, 280)
        // 6, 7
      , translate(10,680,350,460), translate(370,680,620,460)
        // 8, 9, 10
      , translate(10,1150,320,420), translate(340,1150,320,420), translate(670,1150,320,420)
        // 11, 12
      , translate(10,1580,410,410), translate(430,1580,560,410)
        // 13, 14
      , translate(10,2000,485,485), translate(505,2000,485,485)
        // 15, 16
      , translate(10,2495,600,250), translate(620,2495,370,460)
        // 17, 18
      , translate(10,2755,295,470), translate(315,2755,295,470)
        // 19
      , translate(620,2965,370,260)
        // 20, 21
      , translate(10,3235,390,450), translate(410,3235,580,450)
        // 22, 23
      , translate(10,3695,600,310), translate(620,3695,370,310)
      ]
    case 1: return [// wall-2.jpg
        // 1, 2
        translate(10,10,600,450), translate(620,10,370,450)
        // 3, 4
      , translate(10,470,400,400), translate(420,470,570,400)
        // 5, 6
      , translate(10,880,360,260), translate(380,880,610,530)
        // 7
      , translate(10,1150,360,260)
        // 8, 9
      , translate(10,1420,485,485), translate(505,1420,485,485)
        // 10, 11, 12
      , translate(10,1915,360,360), translate(380,1915,300,300), translate(690,1915,300,300)
        // 13
      , translate(10,2285,360,450)
        // 14
      , translate(380,2225,610,510)
        // 15, 16
      , translate(10,2745,530,470), translate(550,2745,440,470)
        // 17, 18, 19
      , translate(10,3225,260,400), translate(280,3225,440,400), translate(730,3225,260,400)
        // 20, 21
      , translate(10,3635,400,400), translate(420,3635,570,400)
      ]
  case 2: return [// wall-3.jpg
      // 1, 2
      translate(10,10,485,485), translate(505,10,485,237.5)
      // 3
    , translate(505,257.5,485,237.5)
      // 4, 5
    , translate(10,505,300,400), translate(420,505,570,300)
      // 6, 7
    , translate(10,815,520,250), translate(540,815,450,530)
      // 8, 9
    , translate(10,1075,255,400), translate(275,1075,255,270)
      // 10
    , translate(10,1485,255,350)
      // 11, 12
    , translate(275,1355,370,480), translate(655,1355,355,480)
      // 13, 14, 15
    , translate(10,1845,300,300), translate(320,1845,360,300), translate(690,1845,300,300)
      // 16, 17
    , translate(10,2155,580,300), translate(600,2155,390,560)
      // 18, 19
    , translate(10,2465,285,560), translate(305,2465,285,560) // 385
      // 20
    , translate(600,2725,390,300)
      // 21, 22
    , translate(10,3035,550,550), translate(570,3035,420,550)
      // 23, 24
    , translate(10,3595,360,460), translate(380,3595,610,460)
    ]
  } // switch
} // getMosaicLayout

export const postListToMosaicList = (posts) => {
  let mosaicList = []
  let postIndex = 0
  while (postIndex < posts.length) {
    // ideally, break large mosaic layout into several sub-mosaics to reduce performance problems
    let layout = getMosaicLayout(mosaicList.length)

    // Reassign layout.index according to what Post.AspectRatio fits layout entry best?
    for (let i = 0; i < layout.length; i++)
      layout[i].index = postIndex + i // sequential.  postIndex + (layout.length - i - 1) // reverse for demo

    // build mosaic detail from layout
    let mosaicHeight = 0
    let postIds = []
    layout.map(function (entry) {
      if (entry.index < posts.length)
        postIds.push(posts[entry.index].PostId)
      if (entry.top + entry.height > mosaicHeight)
        mosaicHeight = entry.top + entry.height
    })
    mosaicList.push({
      startIndex: postIndex,
      count: layout.length,
      hash: postIds.join('-'),
      type: layout.length + '-' + mosaicHeight, // best automatic guess at a reasonable 'type' for recycling 'rows'
      mosaicHeight: mosaicHeight,
      layout: layout,
    })
    postIndex += layout.length
  } // while postIndex
  return mosaicList
} // postListToMosaicList
